import React from 'react'
import { GiCheckMark } from 'react-icons/gi'

interface ProgressStepperProps {
    step: number
    validateStep: (values: any, step: number) => boolean
    setStep: (step: number) => void
    values: any
}

const ProgressStepper: React.FC<ProgressStepperProps> = ({
    step,
    setStep,
    values,
    validateStep,
}) => {
    const totalSteps = 3
    const isStepValid = (values: any, step: number) => {
        const errors = validateStep(values, step)
        return Object.keys(errors).length === 0
    }

    return (
        <div className="flex justify-center items-center mb-4 sticky-top top-20 bg-white pt-10 rtl">
            {[0, 1, 2].map((page, index) => (
                <React.Fragment key={page}>
                    <button
                        className={`mx-3 w-8 h-8 rounded-full flex items-center justify-center z-10 ${
                            step === page || isStepValid(values, page)
                                ? 'bg-green-1 text-white'
                                : 'bg-gray-5 text-gray-2'
                        }`}
                        // onClick={() => setStep(page)}
                    >
                        {step > page ? <GiCheckMark /> : page + 1}
                    </button>
                    {index < totalSteps - 1 && (
                        <div
                            className={`h-1 ${
                                step > index ? 'bg-green-1' : 'bg-gray-5'
                            } flex-1`}
                            style={{
                                height: '3px',
                                width: `calc(100% / ${totalSteps} - 1rem)`,
                            }}
                        />
                    )}
                </React.Fragment>
            ))}
        </div>
    )
}

export default ProgressStepper
